import { Tabs } from "@/components/Elements";
import { usePostViewQuery } from "@/services/modules/post";
import { useMemo } from "react";
import { Articles } from "./article";

enum ArticleTab {
  AllArticles = "All Articles",
  MyArticles = "My Articles",
}

export const ViewArticleScreen = () => {
  usePostViewQuery();

  const tabs = useMemo(
    () => [
      {
        id: ArticleTab.AllArticles,
        label: ArticleTab.AllArticles,
        Content: () => <Articles />,
      },
      {
        id: ArticleTab.MyArticles,
        label: ArticleTab.MyArticles,
        Content: () => <Articles getUserPost />,
      },
    ],
    []
  );

  return (
    <div className="flex-1">
      <Tabs tabs={tabs} />
    </div>
  );
};
